import { useWorkspace } from '@mssgme/hooks';

export function useDomain() {
    const { card } = useWorkspace();
    const domain = card.domain || {};

    return {
        name: '',
        resolved: false,
        secured: false,
        ...domain,
    };
}
